import React from 'react';
import Main from '../components/Apply/Apply';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

function Apply() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default Apply;
